import { render, staticRenderFns } from "./QuestionPage.vue?vue&type=template&id=05a08426&scoped=true&"
import script from "./QuestionPage.vue?vue&type=script&lang=js&"
export * from "./QuestionPage.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPage.vue?vue&type=style&index=0&id=05a08426&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a08426",
  null
  
)

export default component.exports